<template>
  <b-navbar variant="light" toggleable="lg" class="bg-five-fold-primary">
    <b-container>
      <b-navbar-brand class="w-50" :to="{name: 'welcome'}">
        <b-img fluid-grow width="420" src="/img/five-fold-logo-for-dark-background.svg" :alt="$t('five_fold_ministry_test')" />
      </b-navbar-brand>
      <b-navbar-toggle target="nav-collapse">
        <template #default="{ expanded }">
          <fa class="text-light" :icon="expanded? 'chevron-down':'bars'" />
        </template>
      </b-navbar-toggle>
      <b-collapse id="nav-collapse" is-nav>
        <div class="ml-auto">
          <div class="text-light mb-2">
            <span class="text-five-fold-yellow">
              {{ $t('home_page_people_have_taken_the_test', { count: totalTests }) }}
            </span>
          </div>

          <survey-start-button v-if="surveyFull" class="mt-1 float-right" :survey="surveyFull" :disabled="!surveyFull" pill size="lg" variant="light" @click="surveyFull">
            {{ $t('button_begin_test') }}
          </survey-start-button>
        </div>
      </b-collapse>
    </b-container>
  </b-navbar>
</template>

<script>
import { mapGetters } from 'vuex'
import SurveyStartButton from '~/components/surveys/survey-start-button.vue'

export default {
  name: 'FiveFoldHeader',
  components: { SurveyStartButton },
  computed: {
    surveyFull () {
      return this.$store.getters['surveys/surveys'].find(item => item.slug === 'full')
    },
    totalTests () {
      return window.config.testsNumberTotal
    },
    ...mapGetters({
      user: 'auth/user'
    })
  },
  mounted () {
    this.$store.dispatch('surveys/surveys')
  }
}
</script>

<style scoped>

</style>
